// @flow
import React from "react";

require("./styles.scss");

// let intro = require('./cover-desktop.mp4')
// let introMobile = require('./cover-mobile.mp4')
// let introWebM = require('./cover-desktop.webm')
// let introWebMmobile = require('./cover-mobile.webm')

export function cover(props: { title: string, subtitle: string }) {
  // const isMobile = window.innerWidth < 800
  // const isIOS9 = /iPhone OS [6789]_/.test(navigator.userAgent)

  return (
    <div className="cover">
      <video
        autoPlay
        loop
        playsInline
        muted
        poster="https://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/videos/intro.jpg"
      >
        <source
          src="https://interactif.tdg.ch/2020/questions-candidats-conseil-administratif-geneve/videos/intro.mp4"
          type="video/mp4"
        />
      </video>

      <div className="top gradient" />
      <div
        className="ui mobile only"
        style={{
          position: "absolute",
          top: "9em",
          left: 0,
          width: "100vw"
        }}
      >
        <div className="ui text container">
          <div className="">
            <h1
              className="ui inverted left aligned header"
              style={{
                textAlign: "left"
              }}
            >
              {props.title}
            </h1>
            <div className="sub header">{props.subtitle}</div>
          </div>
        </div>
      </div>

      <div
        className="mobile hidden"
        style={{
          position: "absolute",
          bottom: "3em",
          left: 0,
          width: "90vw"
        }}
      >
        <div className="ui left aligned text container">
          <div className="">
            <h1 className="ui inverted header" style={{}}>
              {props.title}
              <div className="sub header">{props.subtitle}</div>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default cover;
